import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { Nillable } from '@web/utils';
import { BannerLocationType } from '../enums/banner-location-type';
import { BannerLocationTypeProviderService } from '../providers/banner-location-type-provider.service';

@Pipe({
  name: 'bannerLocationType',
  standalone: true,
})
export class BannerLocationTypePipe implements PipeTransform {
  private readonly provider = inject(BannerLocationTypeProviderService);

  public transform(location: BannerLocationType): Observable<Nillable<string>> {
    return this.provider.labelFor(location);
  }
}
